import { api } from './api/client'

export default {
    install: function (Vue) {
        Object.defineProperty(Vue.prototype, "$api", { value: api });
    }
}